import { useTranslator } from '@Localization';
import { useConfiguration } from 'common/hooks/useConfiguration';
import { ReactElement } from 'react';

export const LockedContainer = (): ReactElement => {
  const configuration = useConfiguration();

  const { t } = useTranslator();
  const supportEmail = configuration.appConfig.supportEmailAddress;

  return (
    <div>
      <h3>
        {t('locked_account')}
        <a href={`mailto:${supportEmail}`}>{supportEmail}</a>!
      </h3>
    </div>
  );
};
